<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-03 13:49:52
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:16:25
 * @name: 人员列表
 * @Description: 人员列表
 * @FilePath: \project\src\components\public\people-item.vue
 * @Author: desktop
-->
<template>
  <div class="people-list">
    <div class="item">
      <div class="item-info" @click="open = !open">
        <div class="icon">
          <template
            v-if="
              (item.child && item.child.length > 0) ||
              item.department_user.length > 0
            "
          >
            <i class="el-icon-caret-bottom" v-if="open"></i>
            <i class="el-icon-caret-right" v-else></i>
          </template>
        </div>
        <font>{{ item.department_name }}</font>
      </div>
      <div class="item-detail" v-show="open">
        <div
          class="department_user_list"
          v-if="item.department_user && item.department_user.length > 0"
        >
          <div
            class="department_user"
            v-for="itemY of item.department_user"
            :key="itemY.id"
            @click="peopleClickHandler(itemY)"
          >
            <div
              class="checkbox"
              :class="{
                checked: select.findIndex((x) => x.id === itemY.id) > -1,
              }"
            >
              <i
                class="el-icon-check"
                v-if="select.findIndex((x) => x.id === itemY.id) > -1"
              ></i>
            </div>
            <font>{{ itemY.realname }}</font>
          </div>
        </div>
        <div class="child" v-if="item.child && item.child.length > 0">
          <people-item
            @peopleClickHandler="peopleClickHandler"
            :select="select"
            :item="itemZ"
            v-for="itemZ of item.child"
            :key="itemZ.id"
          ></people-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounceation } from '@/utils/decorator';
export default {
  name: "people-item",
  props: {
    item: {
      type: Object,
    },
    select: {
      type: Array,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击人员
     * @param {Number} item 人员信息
     */
    peopleClickHandler(item) {
      this.$emit("peopleClickHandler", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.people-list {
  width: 100%;
  @extend .et-flex-column-normal;
  .item {
    width: 100%;
    @extend .et-flex-column-normal;
    .item-info {
      width: 100%;
      padding: 3px 0;
      @extend .et-flex-start;
      @extend .et-clickElement;
      i {
        width: 15px;
        height: 15px;
        margin-right: 5px;
        font-size: 15px;
      }
    }
    .item-detail {
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      .department_user_list {
        width: 100%;
        @extend .et-flex-column-normal;
        .department_user {
          width: 100%;
          box-sizing: border-box;
          padding: 3px 10px;
          @extend .et-flex-start;
          @extend .et-clickElement;
          .checkbox {
            width: 12px;
            height: 12px;
            margin-right: 5px;
            border: 1px solid $Vars-border-first-color;
            border-radius: $Vars-border-radius-mini;
            &.checked {
              border-color: $Vars-normal-color;
              background: $Vars-normal-color;
            }
            @extend .et-flex-center;
            i {
              font-size: $Vars-font-secondary-size;
              color: white;
            }
          }
        }
      }
      .child {
        width: 100%;
        @extend .et-flex-column-normal;
      }
    }
  }
}
</style>